import { render, staticRenderFns } from "./ReleaseRadioButton.vue?vue&type=template&id=280c6cbf"
import script from "./ReleaseRadioButton.vue?vue&type=script&lang=ts"
export * from "./ReleaseRadioButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports